module.exports = __webpack_public_path__ + "static/media/wide.a64bcf9a.jpg";